export default __webpack_public_path__ + "static/media/smartphone-icon.970220a1.svg";